'use client'

import type { Purchase } from 'my-purchases/types/purchaseList'

import { MultiHeader } from './components/MultiHeader'
import { SimpleHeader } from './components/SimpleHeader'

export function CarouselHeader({
	purchase,
	dataTestId,
	onClick,
}: {
	readonly purchase: Purchase
	readonly dataTestId: string
	readonly onClick: () => void
}) {
	const { orders, link, active } = purchase

	if (orders.length === 1) {
		return (
			<SimpleHeader
				order={orders[0]}
				link={link}
				onClick={onClick}
				dataTestId={dataTestId}
				isActive={active}
			/>
		)
	}

	return (
		<MultiHeader
			orders={orders}
			link={link}
			onClick={onClick}
			dataTestId={dataTestId}
			isActive={active}
		/>
	)
}
